import { render, staticRenderFns } from "./ProxerProjectCard.vue?vue&type=template&id=4e516442&scoped=true&"
import script from "./ProxerProjectCard.vue?vue&type=script&lang=js&"
export * from "./ProxerProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ProxerProjectCard.vue?vue&type=style&index=0&id=4e516442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e516442",
  null
  
)

export default component.exports